
import { useAuthContext } from '../hooks/useAuthContext';
import axios from 'axios';

/* export const _FETCH = (query) => {
    return SClient
    .fetch(query)
} */


/* export const _GETDOCUMENT = (documentId) => {
    return SClient
    .getDocument(documentId)
} */

/* export const _ADDFILE = (data)=>{
    SClient.assets
    .upload( data.fileType, data.file, { contentType: data.file.type, filename: data.file.name })
} */



/**
 * Makes a POST request to the given route with the given query.
 * Requires a route, user object with a token, and query object.
 * onSuccess and onError callbacks are optional and will be called with the response data or error message, respectively.
 * 
 * @param {Object} params - object with route, user, query, onSuccess, and onError properties
 * @param {string} params.route - the route to make the request to
 * @param {Object} params.user - object with a token property
 * @param {Object} params.query - the query object to send with the request
 * @param {Function} params.onSuccess - callback to call with response data on success
 * @param {Function} params.onError - callback to call with error message on failure
 * @returns {Promise<Object>} - promise that resolves with the response data or rejects with an error
 */
export const _FETCH = async ({route, user, query, onSuccess=()=>{}, onError=()=>{}}) => {
  
    try{
        if(!route) throw Error('no route')
        if(!user) throw Error('no user')
        if(!user.token) throw Error('no token')
        if(!query) throw Error('no query')

        const response = await axios.post(route, {
            query }, {
            withCredentials: true,    
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
          });
        
        //const json = await response.json()
        //if(!json) throw Error('no response')
        const data = response.data   
        //console.log("_FETCH SUCCESS", response)

        onSuccess(data)
        return data
    } catch(e) {
        console.log("_FETCH ERROR", e)
        onError(e)
        return ({error:e?.message})
    }
    }
    



 
/*  export const useQueryDocuments = ({...props}) => {
    return useMutation(_FETCH,{...props})
} */








